import "../packs/core/services/analytics/cmp/bootstrap-cmp";
import {loadComponent} from "../packs/config/loader";
import {GroupActionsOrdering} from "../packs/core/modules/group-actions-ordering/pages";
import {AnalyticsHub} from "../packs/core/services/analytics/analytics-hub";

document.addEventListener("DOMContentLoaded", () => {
	loadComponent(GroupActionsOrdering, document.getElementById("b2b-group-actions-js"));

	let node = document.getElementById("analytics-hub-js");
	if (!node) {
		node = document.createElement("div");
		node.id = "analytics-hub-js";
		document.body.appendChild(node);
	}
	loadComponent(AnalyticsHub, node);
});
